import styled from "@emotion/styled";

// @ts-expect-error
import units from "design-units";

export const LOGIN_COLOR = "#01caff";
export const LOGIN_FONT_SIZE = "14px";

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
`;

export const LeftPaneWrapper = styled.div`
  min-height: 100vh;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  width: 33%;
  padding: 50px;
  padding-top: 15px;
  padding-right: 60px;
  box-shadow: 1px 0 3px -2px #888;
  font-size: ${LOGIN_FONT_SIZE};
  ${units({
    backgroundColor: "white",
    borderRight: "1px solid",
    borderColor: "lightGrey",
  })};
`;

export const LogoWrapper = styled.div`
  position: absolute;
  width: 120px;
  pointer-events: none;
  margin-top: 20px;
`;

export const LogoImgWrapper = styled.img`
  width: 100%;
  pointer-events: none;
`;

export const TextFieldTitleWrapper = styled.div`
  margin-top: 15px;
`;

export const CenterWrapper = styled.div`
  position: absolute;
  width: 25%;
  min-width: 230px;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
`;

export const BottomWrapper = styled.div`
  position: fixed;
  width: 33%;
  min-width: 320px;
  left: 0%;
  right: 0%;
  bottom: 3%;
`;
